module.exports = __webpack_public_path__ + "static/img/gd-09.14c9ee6d.jpg";